import Vue from 'vue';
import router from '../router';
import store from '../store/index';
import Echo from 'laravel-echo';
import JwtService from './jwt.service';
import { EventBus } from './event-bus';
import Notify from './notification';
import io from 'socket.io-client';

const EchoService = {
    init() {
        window.io = io;

        window.Echo = new Echo({
            broadcaster: 'reverb',
            host:
                process.env.NODE_ENV === 'production'
                    ? 'wss://api.sistemacpv.com.br:8080' // HTTPS + porta do Reverb
                    : 'ws://localhost:8080', // Desenvolvimento local
            auth: {
                headers: {
                    Authorization: `Bearer ${JwtService.getToken()}`,
                },
            },
        });

        window.Echo.connector.socket.on('connect', () => {
            store.commit('updatePusherStatus', 'connected');
        });

        window.Echo.connector.socket.on('disconnect', () => {
            store.commit('updatePusherStatus', 'disconnected');
        });

        window.Echo
            .private(`App.User.${store.state.auth.user.id}`)
            .listen('.NotifyUserOnPrivateChannel', (e) => {
                // evento exemplo
                console.log('Notificação recebida', e);
            })
            .listen('.ApplicationCreated', (e) => {
                Notify.notify('Alfred', 'Nova aplicação criada');
            })
            .error((error) => {
                store.commit('updatePusherStatus', error.type);
            });
    },
};

export default EchoService;
